export default "__VITE_ASSET__sX1bfij3__"